export const LOGGED_IN_USER = "loggedInUser";